(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('ClinicNameDialogController', ClinicNameDialogController);

    ClinicNameDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ClinicName'];

    function ClinicNameDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, ClinicName) {
        var vm = this;
        vm.clinicName = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:clinicNameUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.clinicName.id !== null) {
                ClinicName.update(vm.clinicName, onSaveSuccess, onSaveError);
            } else {
                ClinicName.save(vm.clinicName, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
